var _defs, _path, _mask;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconOceanView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_ocean_view_svg__a",
    d: "M0 32h32V0H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.437 7.63h-.002.002L4.153 9.161l3.64 3.057h.001l1.285-1.53L5.437 7.63z",
    fill: props.color
  }), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon_ocean_view_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_ocean_view_svg__a"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    mask: "url(#icon_ocean_view_svg__b)",
    d: "M15 7.925h2V3.171h-2zM23.087 4.964l-1.812-.846-2.009 4.31 1.812.845v0l2.01-4.309zM22.921 10.687l1.284 1.531 3.642-3.056-1.285-1.532zM14.277 27.83h6.445v-2h-6.445zM11.229 16.798c.19-.92.645-1.766 1.324-2.445A4.843 4.843 0 0116 12.925c1.302 0 2.526.507 3.446 1.428a4.838 4.838 0 011.325 2.445h-9.542zm11.564 0a6.803 6.803 0 00-1.933-3.859A6.823 6.823 0 0016 10.925a6.829 6.829 0 00-4.861 2.014 6.811 6.811 0 00-1.932 3.86H1.88v2H30.119v-2h-7.326zM12.128 21.826h11.743v-2H12.128zM8.277 24.83h10.445v-2H8.277zM12.733 8.427l-2.01-4.309-1.811.845v.001l2.009 4.31v-.002z"
  })));
}

export default SvgIconOceanView;